module.exports = __webpack_public_path__ + "img/sos_poster.e55835bd.png";